import React from 'react';

export default function ModeToggle({ mode, onChange }) {
  const isRuach = mode === 'ruach';

  return (
    <div style={{
      display: 'flex', alignItems: 'center',
      background: 'rgba(255,255,255,0.04)',
      border: '1px solid rgba(255,255,255,0.1)',
      borderRadius: '8px', padding: '3px', gap: '2px',
      flexShrink: 0,
    }}>
      <button
        onClick={() => onChange('science')}
        style={{
          padding: '5px 12px', borderRadius: '6px', border: 'none',
          fontSize: '0.68rem', fontFamily: 'Space Mono, monospace',
          letterSpacing: '0.08em', cursor: 'pointer',
          background: !isRuach ? 'rgba(240,192,64,0.2)' : 'transparent',
          color: !isRuach ? '#f0c040' : 'rgba(255,255,255,0.35)',
          transition: 'all 0.2s',
          fontWeight: !isRuach ? 700 : 400,
        }}
      >
        SCIENCE
      </button>
      <button
        onClick={() => onChange('ruach')}
        style={{
          padding: '5px 12px', borderRadius: '6px', border: 'none',
          fontSize: '0.68rem', fontFamily: 'Space Mono, monospace',
          letterSpacing: '0.08em', cursor: 'pointer',
          background: isRuach ? 'rgba(255,160,60,0.2)' : 'transparent',
          color: isRuach ? '#ffb060' : 'rgba(255,255,255,0.35)',
          transition: 'all 0.2s',
          fontWeight: isRuach ? 700 : 400,
        }}
      >
        RUACH · רוּחַ
      </button>
    </div>
  );
}
